import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import RichContent from '../../uielements/RichContent/richContent'
import LogoIcon from '../../uielements/LogoIcon'
import FlexWrapper from '../../uielements/flexWrapper'
import CurvyMore from '../../uielements/CurvyMore'
import { theme } from '../../theme/theme'
import { Box, Container, Heading, useColorModeValue } from '@chakra-ui/react'
import ParallaxButton from '../../uielements/ParallaxButton'
import { localisedLink } from '../../utils/utils'
import { PAGE_SLUG } from '../../lib/constants'

const BgImage = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    opacity: 0.15;
`

const OurValues = () => {
    const { t, i18n } = useTranslation()
    const arrowColor = useColorModeValue('blue', 'white')
    const logoColor = useColorModeValue('blue', 'white')

    const ourValues = useStaticQuery(
        graphql`
            query FetchOurValues {
              allContentfulPage(filter:{slug: {eq: "oi-aksies-mas"}}) {
                nodes {
                  id
                  title
                  slug
                  excerpt {
                    raw
                  }
                  node_locale
                }
              }
            }
        `
    )

    return (
        <Box pos={'relative'}>
            {ourValues.allContentfulPage.nodes.map(
                (value) =>
                    value.node_locale === i18n.language && (
                        <FlexWrapper
                            justifyContent="space-evenly"
                            flexDirection="column"
                            className="fullHeight"
                            alignItems="center"
                            key={value.id}
                        >
                            <Heading as={'h2'} size={'2xl'} pt={8} mt={12} mb={4}>
                                {value.title}
                            </Heading>
                            <Container mt={12}>
                                <RichContent body={value.excerpt} locale={i18n.language} />
                                <BgImage>
                                    <LogoIcon width="110" color={logoColor} />
                                </BgImage>
                            </Container>
                            <Box mb={24}>
                                <ParallaxButton
                                    textStyle="uppercase"
                                    link={localisedLink(value.node_locale, PAGE_SLUG, value.slug)}
                                    arrowColor={arrowColor}
                                    accentColor={'brand.blue'}
                                    textColor={'brand.blue'}
                                >
                                    {t('read-more-no-tone')}
                                </ParallaxButton>
                            </Box>
                        </FlexWrapper>
                    )
            )}
        </Box>
    )
}

export default OurValues
